// src/Pages/Onboarding/ZidOnboarding/BusinessInformation/BusinessInformation.jsx
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { message } from 'antd'    // ← import message

export default function BusinessInformation({
  initialCompanyName,
  initialWebsite,
  onVerified
}) {
  const { t } = useTranslation()
  const [subStep, setSubStep]       = useState(1)
  const [companyName, setCompanyName] = useState(initialCompanyName || '')
  const [website, setWebsite]         = useState(initialWebsite || '')
  const [revenue, setRevenue]         = useState('')
  const [language, setLanguage]       = useState('')
  const [industry, setIndustry]       = useState('')

  const next = () => {
    if (subStep === 1) {
      if (!companyName.trim() || !website.trim()) {
        return message.error(
          t('zidOnboarding.businessInformation.errors.fillCompanyAndWebsite')
        )
      }
      setSubStep(2)
    } else {
      if (!language || !industry) {
        return message.error(
          t('zidOnboarding.businessInformation.errors.selectLanguageAndIndustry')
        )
      }
      onVerified({ companyName, website, revenue, language, industry })
    }
  }

  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-8 space-y-6">
        {subStep === 1 ? (
          <>
            <h2 className="text-2xl font-bold text-gray-900">
              {t('zidOnboarding.businessInformation.steps.infoTitle')}
            </h2>

            {/* Company Name */}
            <label className="block text-gray-700">
              {t('zidOnboarding.businessInformation.fields.companyName')}*
            </label>
            <input
              type="text"
              value={companyName}
              onChange={e => setCompanyName(e.target.value)}
              placeholder={t('zidOnboarding.businessInformation.placeholders.companyName')}
              className="w-full p-3 border border-gray-300 rounded-lg focus:border-purple-600"
            />

            {/* Website */}
            <label className="block text-gray-700">
              {t('zidOnboarding.businessInformation.fields.website')}*
            </label>
            <input
              type="url"
              value={website}
              onChange={e => setWebsite(e.target.value)}
              placeholder={t('zidOnboarding.businessInformation.placeholders.website')}
              className="w-full p-3 border border-gray-300 rounded-lg focus:border-purple-600"
            />

            {/* Revenue */}
            <label className="block text-gray-700">
              {t('zidOnboarding.businessInformation.fields.revenue')}{' '}
              <span className="text-gray-400">
                {t('zidOnboarding.businessInformation.optional')}
              </span>
            </label>
            <input
              type="number"
              value={revenue}
              onChange={e => setRevenue(e.target.value)}
              placeholder={t('zidOnboarding.businessInformation.placeholders.revenue')}
              className="w-full p-3 border border-gray-300 rounded-lg focus:border-purple-600"
            />
          </>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-gray-900">
              {t('zidOnboarding.businessInformation.steps.preferencesTitle')}
            </h2>

            {/* Language */}
            <label className="block text-gray-700">
              {t('zidOnboarding.businessInformation.fields.language')}*
            </label>
            <select
              value={language}
              onChange={e => setLanguage(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:border-purple-600 bg-white"
            >
              <option value="">
                {t('zidOnboarding.businessInformation.placeholders.selectLanguage')}
              </option>
              <option>English</option>
              <option>Arabic</option>
            </select>

            {/* Industry */}
            <label className="block text-gray-700">
              {t('zidOnboarding.businessInformation.fields.industry')}*
            </label>
            <select
              value={industry}
              onChange={e => setIndustry(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:border-purple-600 bg-white"
            >
              <option value="">
                {t('zidOnboarding.businessInformation.placeholders.selectIndustry')}
              </option>
              <option>Technology</option>
              <option>Healthcare</option>
              <option>Retail</option>
            </select>
          </>
        )}

        <button
          onClick={next}
          className="w-full py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition"
        >
          {subStep === 1
            ? t('zidOnboarding.businessInformation.buttons.next')
            : t('zidOnboarding.businessInformation.buttons.finish')}
        </button>
      </div>
    </div>
  )
}
